<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <span class="flex-grow-1" v-if="name"><b>{{ $t('startInfoIntro') }}</b> {{name}}</span>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <div class="row col-12">
                    <div class="d-flex flex-column col-12 col-md-4 col-lg-2">
                        <!-- Photo -->
                        <div role="group" class="form-group">
                            <GalleryPicker class="gallery-picker" v-model="startInfo.photo" :ratioWidth="9" :ratioHeight="16" v-bind:class="{'is-invalid': genericValidator(startInfo.photo) === false || errorValidator('Photo') === false }" :max="1"></GalleryPicker>
                        </div>
                        <!-- Icon -->
                        <div role="group" class="form-group">
                            <GalleryPicker class="gallery-picker" v-model="startInfo.icon" :ratioWidth="1" :ratioHeight="1" v-bind:class="{'is-invalid': errorValidator('Icon') === false }" :max="1"></GalleryPicker>
                        </div>
                    </div>
                    <div class="d-flex flex-column col-12 col-md-8 col-lg-10">
                        <!-- Titles -->
                        <div role="group" class="form-group flex-grow-1">
                            <label class=""> {{ $t('nameMandatory') }}</label>
                            <CInput type="text" v-model="startInfo.titles[currentLanguage.key]" :invalid-feedback="errorOutput['Titles']" :is-valid="genericValidator(startInfo.titles) && errorValidator('Titles')"></CInput>
                        </div>
                        <!-- Description -->
                        <div role="group" class="form-group flex-grow-1">
                            <label class=""> {{ $t('descriptionMandatory') }}</label>
                            <VueEditor v-model="startInfo.texts[currentLanguage.key]" v-bind:class="{'is-invalid': genericValidator(startInfo.texts) == false || errorValidator('Texts') }"></VueEditor>
                            <div v-if="errorOutput['Texts']" class="invalid-feedback">{{errorOutput['Texts']}}</div>
                        </div>
                        <!-- Button primary -->
                        <div role="group" class="form-group flex-grow-1">
                            <label class=""> {{ $t('buttonPrimaryMandatory') }}</label>
                            <CInput type="text" v-model="startInfo.buttonPrimaries[currentLanguage.key]" :invalid-feedback="errorOutput['ButtonPrimaries']" :is-valid="genericValidator(startInfo.buttonPrimaries) && errorValidator('ButtonPrimaries')"></CInput>
                        </div>
                        <!-- Button secondary -->
                        <div role="group" class="form-group flex-grow-1">
                            <label class=""> {{ $t('buttonSecondary') }}</label>
                            <CInput type="text" v-model="startInfo.buttonSecondaries[currentLanguage.key]" :invalid-feedback="errorOutput['ButtonSecondaries']" :is-valid="errorValidator('ButtonSecondaries')"></CInput>
                        </div>
                        <!-- Button secondary link -->
                        <div role="group" class="form-group flex-grow-1">
                            <label class=""> {{ $t('buttonSecondaryLink') }}</label>
                            <CInput type="text" v-model="startInfo.buttonSecondaryLinks[currentLanguage.key]" :invalid-feedback="errorOutput['ButtonSecondaryLinks']" :is-valid="errorValidator('ButtonSecondaryLinks')"></CInput>
                        </div>
                    </div>
                </div>
                <!-- Action button + submitting -->  
                <div role="group" class="form-group flex-grow-1 d-flex justify-content-end">
                    <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                    <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                </div>
                <!-- submitting -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import StartInfo from "@/classes/StartInfo";
import { mapState, mapActions } from 'vuex'
import LanguageDropdown from "@/controls/LanguageDropdown.vue";
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import GalleryPicker from '@/controls/GalleryPicker.vue'
import { VueEditor } from "vue2-editor";
import FormLoading from '@/controls/FormLoading.vue'
import InputGetList from "@/classes/InputGetList";
import { genericValidator, errorValidator, deepClone } from "@/helpers/utils.js";
import { API_HELPER } from "@/helpers/api.js";
import CustomPicker from '@/controls/CustomPicker.vue'

  export default {
  components: { LanguageDropdown, ConfirmationPopUp, GalleryPicker, VueEditor, FormLoading, CustomPicker },
    props:{    
        baseStartInfo:
        {
            type: Object,
            default: null,
        },
        baseStartInfoName:
        {
            type: String,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            triedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            startInfo: new StartInfo({},{},{},{},{}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },
    mounted: function()
    {
        this.resetStartInfo();
    },
    computed:
    {
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = [];

            if(this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput))
            {
                result = this.alertOutput.reduce(function(accum, currentVal) {
                accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate multilanguage fields
            for (const [key, value] of Object.entries(this.startInfo.titles)) { if(!value) { result['Titles'] = this.$i18n.t("validateAllTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.startInfo.titles)) { if(!value) { result['Texts'] = this.$i18n.t("validateAllTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.startInfo.titles)) { if(!value) { result['ButtonPrimaries'] = this.$i18n.t("validateAllTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.startInfo.titles)) { if(!value) { result['ButtonSecondaries'] = this.$i18n.t("validateAllTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.startInfo.titles)) { if(!value) { result['ButtonSecondaryLinks'] = this.$i18n.t("validateAllTranslations"); break; }; }

            return result;
        },
        ...mapState('startInfos', ['postStartInfoOutput']),
        ...mapState('startInfos', ['putStartInfoOutput']),
        name: function()
        {
            return this.baseStartInfo || this.baseStartInfoName ? (this.baseStartInfo ? this.baseStartInfo.name : this.baseStartInfoName) : null;
        }
    },
    methods:{
        resetStartInfo(){
            if(!this.baseStartInfo)
            {
                var titles = {}; var texts = {}; var buttonPrimaries = {}; var buttonSecondaries = {}; var buttonSecondaryLinks = {};
                CONSTANTS.supportedLanguages.forEach(language => { titles[language.key] = ""; texts[language.key] = ""; buttonPrimaries[language.key] = ""; buttonSecondaries[language.key] = ""; buttonSecondaryLinks[language.key] = ""; });

                this.startInfo = new StartInfo(titles, texts, buttonPrimaries, buttonSecondaries, buttonSecondaryLinks);
            }
            else
            {
                this.startInfo = deepClone(new StartInfo, this.baseStartInfo);    
                this.startInfo.photo = {url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.startInfo.photoPath])};    
                this.startInfo.file = this.startInfo.filePath;
            }
        },
        submitClicked(){
            this.triedSubmit = true;
            // Emit event
            if(this.startInfo.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.startInfo);
            }
            else
            {
                alert(this.$i18n.t("invalidInfoError"));
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            this.$router.push({name: "StartInfosList" });
        },
        genericValidator,
        errorValidator
    },
    watch:
    {
        postStartInfoOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        putStartInfoOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        baseStartInfo: function()
        {
            this.resetStartInfo();
        },
        alertType: function()
        {
            this.submitting = false;
        },
        alertOutput: function()
        {
            this.submitting = false;

            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

</style> 